import { useEffect, useState } from "react";
import { api } from "@/lib/leuteliaApi";
import { SectionHead } from "./ModuleShell";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } from "recharts";
import { Brain, History } from "lucide-react";
import { TT } from "./ChartKit";

const Card = ({ className = "", children, ...p }) => <div className={`bg-white rounded-xl border border-brand-gold/25 p-5 ${className}`} {...p}>{children}</div>;
const Head = ({ t, s }) => <><div className="text-[13px] font-semibold text-brand-ink">{t}</div><div className="text-[11.5px] text-brand-muted mb-2">{s}</div></>;

export default function SitoCharts({ ccu, scope, ext }) {
  const [hist, setHist] = useState(null);
  useEffect(() => { api.externalHistory(scope.tenant, scope.hotel).then(setHist).catch(() => setHist({ scans: [] })); }, [scope.tenant, scope.hotel, ccu.understanding_version]);
  const scans = hist?.scans || [];
  const trend = scans.slice(-8).map((s, i) => ({ name: `#${i + 1}`, immagini: s.metrics.images, link: s.metrics.links, criticita: s.metrics.criticalities }));

  return (
    <>
      <section className="mb-8" data-testid="sito-memory">
        <SectionHead icon={Brain} title="Memoria e apprendimento" sub="LEUTELIA ricorda ogni scansione e impara dai cambiamenti: ecco cosa è cambiato tra una scansione e l'altra." />
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-4">
          <Card>
            <Head t="Andamento tra scansioni" s={`${scans.length} scansioni memorizzate`} />
            {trend.length > 1 ? (
              <ResponsiveContainer width="100%" height={170}>
                <BarChart data={trend} margin={{ left: -20, right: 8 }}><XAxis dataKey="name" tick={{ fontSize: 11 }} axisLine={false} tickLine={false} /><YAxis tick={{ fontSize: 10 }} axisLine={false} tickLine={false} allowDecimals={false} /><Tooltip {...TT} cursor={{ fill: "#F5F1E8" }} />
                  <Bar dataKey="immagini" fill="#16493A" radius={[4, 4, 0, 0]} barSize={10} /><Bar dataKey="link" fill="#C6902A" radius={[4, 4, 0, 0]} barSize={10} /><Bar dataKey="criticita" name="criticità" fill="#B0452E" radius={[4, 4, 0, 0]} barSize={10} /></BarChart>
              </ResponsiveContainer>
            ) : <div className="text-[13px] text-brand-muted italic py-6">Serve almeno una seconda scansione per mostrare l'andamento. Il direttore può rilanciarla più volte a settimana.</div>}
          </Card>
          <Card>
            <Head t="Cosa ha imparato LEUTELIA" s="Delta deterministici tra scansioni consecutive" />
            <div className="divide-y divide-brand-gold/15 max-h-[220px] overflow-auto leutelia-scroll">
              {scans.length === 0 && <div className="text-[13px] text-brand-muted italic py-3">Nessuna scansione memorizzata per questo hotel.</div>}
              {[...scans].reverse().slice(0, 6).map((s, i) => (
                <div key={i} className="py-2.5 flex gap-3" data-testid="scan-entry">
                  <History size={15} className="text-brand-gold shrink-0 mt-0.5" />
                  <div className="min-w-0"><div className="text-[11px] font-mono text-brand-muted">{new Date(s.at).toLocaleString("it-IT")} · {s.kind === 'onboarding' ? 'prima analisi' : 'nuova scansione'} · versione {s.understanding_version}</div>
                    {(s.learned || []).length ? s.learned.map((l, j) => <div key={j} className="text-[12.5px] text-brand-ink">• {l}</div>) : <div className="text-[12.5px] text-brand-muted">Prima scansione: base di conoscenza creata.</div>}</div>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </section>
    </>
  );
}
